export default __webpack_public_path__ + "static/media/aavax.027a4e50.svg";